import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import notify from 'devextreme/ui/notify';
import ValidationEngine from 'devextreme/ui/validation_engine';
import { NOT_FOUND } from 'http-status-codes';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SupplyCategory } from '../../../shared/models/ocl';
import { FusionAuthService } from '../../../shared/services/fusion-auth';
import { ScreenService } from '../../../shared/services/general';
import { LabSettingsService, SupplyService } from '../../../shared/services/ocl';

@Component({
  selector: 'app-supply-request',
  templateUrl: './supply-request.component.html',
  styleUrls: ['./supply-request.component.scss']
})
export class SupplyRequestComponent implements OnInit, OnDestroy {
    public supplyRequestForm: UntypedFormGroup;
    public isLoading = false;
    public role: string = '';
    public phonePattern: any = /^\d*$/;
    public supplyCategories: SupplyCategory[] = [];
    public user: any;
    public configDataSource: any;
    public isPhoneOrTablet: boolean = false;
    private onDestroy$: Subject<void> = new Subject<void>();

    constructor(private fb: UntypedFormBuilder, private authService: FusionAuthService, private supplyService: SupplyService,
                private settingService: LabSettingsService, private sanitizer: DomSanitizer, private screen: ScreenService) {
        this.supplyRequestForm = this.fb.group({
            firstName: new UntypedFormControl('', [Validators.required]),
            lastName: new UntypedFormControl('', [Validators.required]),
            email: new UntypedFormControl('', [Validators.required]),
            phone: new UntypedFormControl(''),
            message: new UntypedFormControl(''),
            client: new UntypedFormControl(null, [Validators.required]),
            supplies: new UntypedFormControl(null),
        });

        this.getFilteredConfigs = this.getFilteredConfigs.bind(this);
    }

    public ngOnInit() {
        this.isLoading = true;
        this.user = this.authService.Profile;
        this.configDataSource = [
            { name: 'Count'},
            { name: 'Box'},
            { name: 'Case'}
        ];
        this.initForm();

        this.isPhoneOrTablet = this.screen.sizes['screen-x-small'] || this.screen.sizes['screen-small'] || this.screen.sizes['screen-tablet'];
        this.screen.changed.pipe(takeUntil(this.onDestroy$)).subscribe(() => {
            this.isPhoneOrTablet = this.screen.sizes['screen-x-small'] || this.screen.sizes['screen-small'] || this.screen.sizes['screen-tablet'];
        });
    }

    private initForm() {
        this.supplyRequestForm.get('firstName')?.setValue(this.user.firstName);
        this.supplyRequestForm.get('lastName')?.setValue(this.user.lastName);
        this.supplyRequestForm.get('email')?.setValue(this.user.email);
        this.role = this.user.registrations[0].roles[0];

        this.settingService.getWebSupplyCategorySettings().pipe(takeUntil(this.onDestroy$)).subscribe(result => {
            this.supplyCategories = result;
            this.isLoading = false;
        });
    }

    public getFilteredConfigs(options: any) {
        return {
            store: this.configDataSource,
            filter: options.data ? options.data.config.length === 1 ? ['name', '=', options.data.config[0]] : options.data.config.length === 2 ?
                [['name', '=', options.data.config[0]], 'or' , ['name', '=', options.data.config[1]]] : options.data.config.length === 3 ?
                [['name', '=', options.data.config[0]], 'or' , ['name', '=', options.data.config[1]], 'or' , ['name', '=', options.data.config[2]]] : null : null
        };
    }

    private clear() {
        this.isLoading = true;
        this.supplyRequestForm.reset();
        ValidationEngine.resetGroup('supplyRequestForm');
        this.supplyRequestForm?.get('message')?.setValue('<html lang="eng"><head></head><body></body></html>');
        this.initForm();
    }

    public submit() {
        const form = ValidationEngine.validateGroup('supplyRequestForm');
        if (form.isValid) {
            /*if (this.supplyRequestForm.get('message').value === null || this.supplyRequestForm.get('message').value === '' ||
                this.supplyRequestForm.get('message').value.indexOf('<p>') === -1) {
                notify('You need to enter a message', 'error', 3000);
            } else {*/
                this.isLoading = true;
                this.supplyCategories.forEach(x => {
                    x.supplies = x.supplies.filter(y => y.quantity !== null && y.configSelected !== null);
                });

                const supply = {
                    name: this.supplyRequestForm.get('firstName')?.value + ' ' + this.supplyRequestForm.get('lastName')?.value,
                    email: this.supplyRequestForm.get('email')?.value,
                    phone: this.supplyRequestForm.get('phone')?.value,
                    client: this.supplyRequestForm.get('client')?.value.name,
                    message: this.supplyRequestForm.get('message')?.value.toString().replace('<p>', '<p style="text-transform: uppercase">'),
                    supplies: this.supplyCategories.filter(x => x.supplies.length > 0)
                };
                this.supplyService.sendEmail(supply).pipe(takeUntil(this.onDestroy$)).subscribe(response => {
                    this.isLoading = false;
                    if (response === false) {
                        notify('There was an error sending the mail', 'error', 3000);
                    } else {
                        notify('The email was sent successfully', 'success', 3000);
                        this.clear();
                    }
                }, (error) => {
                    if (error.status === NOT_FOUND) {
                        notify('This feature is not configured by the lab', 'error', 3000);
                    } else {
                        notify('We are having trouble communicating with our servers!', 'error', 3000);
                    }
                });
          //  }
        }
    }

    public transformYourHtml(htmlTextWithStyle: string) {
        return this.sanitizer.bypassSecurityTrustHtml(htmlTextWithStyle);
    }

    public ngOnDestroy(): void {
        this.onDestroy$.next(); this.onDestroy$.complete();
    }
}
